
// Libraries
import { defineComponent } from 'vue';
import { mapStores } from 'pinia';

// Components
import Checkbox from 'client/components/forms/Checkbox.vue';
import LoginActionButton from 'client/components/LoginActionButton.vue';
import LoginAlert from 'client/components/LoginAlert.vue';
import LoginTextField from 'client/components/LoginTextField.vue';
import UserLoginStore from 'client/stores/UserLoginStore';

// Services
import LocalStorageService from 'client/util/LocalStorageService';

// Constants
import { LocalStorageConsts } from 'client/util/Constants';
import { useLoginLabels } from 'client/util/Constants/LoginLabels';

// Utils
import { datadogRum } from '@datadog/browser-rum-slim';

const {
  userLoginEmail,
} = LocalStorageConsts;

export default defineComponent({
  name: 'EmailEntry',

  inject: {
    $validator: {
      from: '$validator',
    },
  },

  components: {
    Checkbox,
    LoginActionButton,
    LoginAlert,
    LoginTextField,
  },

  props: {
    redirectTo: {
      type: String,
      default: '',
    },
    successMessage: {
      type: String,
      default: '',
    },
    isSecondarySubmitButton: {
      type: Boolean,
      default: false,
    },
  },

  setup() {
    const uiLabel = useLoginLabels();
    return { uiLabel };
  },

  mounted() {
    this.userLoginStore.password = '';
  },

  data() {
    return {
      hasTracked: false,
      isLoading: false,
    };
  },

  computed: {
    ...mapStores(UserLoginStore),

    disableButton() {
      const errors = this.$validator.errors.items.length > 0;
      return errors || !this.userLoginStore.email.length;
    },
  },

  methods: {
    handleFocus() {
      if (!this.hasTracked) {
        this.hasTracked = true;
        // Identify JS errors that cause the page not to load for specific browsers
        datadogRum.addAction('user-ready');
      }
    },

    handleInput(isChecked: boolean) {
      if (!isChecked) {
        LocalStorageService.removeItem(userLoginEmail);
      }
    },

    handleClick() {
      this.isLoading = true;
      const { email } = this.userLoginStore;
      const redirectToParam = this.redirectTo;
      const payload = redirectToParam ? { email, redirectTo: redirectToParam } : { email };

      this.$emit('submitEmail', payload);
    },
  },
});
